module.exports = __webpack_public_path__ + "img/sudan.4fdee81.webp";